"use client";

import { useTranslations } from "use-intl";

import { PersonIcon } from "@/components/appIcons";
import { FilterSelect, type FilterOption } from "@/components/ui/filter-select";

interface ArtistFilterSelectProps {
  options: FilterOption[];
  value: string | null;
  onChange: (value: string | null) => void;
}

export function ArtistFilterSelect({ options, value, onChange }: ArtistFilterSelectProps) {
  const t = useTranslations("shared.releaseFilters");

  return (
    <FilterSelect
      icon={PersonIcon}
      placeholder={t("artist")}
      options={options}
      value={value}
      onChange={onChange}
      searchable
      searchPlaceholder={t("searchArtist")}
    />
  );
}
